<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script setup>
</script>

<style>
body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
